import {
  correctPhoneNumber,
  hasMinLength,
  isSelected,
  hasStringValue,
  maxLengthNotExceeding
} from "@utilities";

const WhoOpenAccount = [
  {
    field: "clientProfile.0.data.whoOpenAccount",
    validation: hasStringValue
  }
];

const clientCeo = [
  {
    field: "clientCeo.0.data.clientCeoName",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.otherCeoCitizien",
    validation: isSelected
  },
  {
    field: "clientCeo.0.data.clientCeoSurname",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.clientCeoId",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.clientCeoId",
    validation: hasMinLength(4)
  },
  {
    field: "clientCeo.0.data.clientCeoId",
    validation: maxLengthNotExceeding(35)
  },
  {
    field: "clientCeo.0.data.clientCeoCitizien",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.managerBirthDate",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.otherCeoCitizien",
    validation: isSelected
  }
];

const otherCeoCitizien = [
  {
    field: "clientCeo.0.data.otherCeoCitDocTy",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.otherCeoCitDocNo",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.otherCeoCitDocNo",
    validation: maxLengthNotExceeding(20)
  },
  {
    field: "clientCeo.0.data.otherCeoCitDocCountry",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.otherCeoCitizienSch",
    validation: isSelected
  }
];

const clientCeoAddress = [
  {
    field: "clientCeo.0.data.clientCeoCountry",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.clientCeoCity",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.clientCeoStreet",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.clientCeoPhone",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.clientCeoPhone",
    validation: correctPhoneNumber
  },
  {
    field: "clientCeo.0.data.clientCeoPhone",
    validation: hasMinLength(8)
  },
  {
    field: "clientCeo.0.data.clientCeoPhone",
    validation: maxLengthNotExceeding(20)
  }
];

const clientCeoDocs = [
  {
    field: "clientCeo.0.data.clientCeoIdDocType",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.clientCeoDocNo",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.clientCeoDocNo",
    validation: maxLengthNotExceeding(20)
  },
  {
    field: "clientCeo.0.data.clientCeoDocCountry",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.clientCeoDocIssueDate",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.clientCeoDocValidDate",
    validation: hasStringValue
  }
];

const clientRep = [
  {
    field: "clientRep.0.data.clientRepName",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepSurname",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepId",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepId",
    validation: hasMinLength(4)
  },
  {
    field: "clientRep.0.data.clientRepId",
    validation: maxLengthNotExceeding(35)
  },
  {
    field: "clientRep.0.data.clientRepRegCountry",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepBirthDate",
    validation: hasStringValue
  },
  {
    field: "clientCeo.0.data.otherCeoCitizien",
    validation: isSelected
  }
];

const clientRepAddress = [
  {
    field: "clientRep.0.data.clientRepCountry",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepCity",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepPhoneNo",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepPhoneNo",
    validation: correctPhoneNumber
  },
  {
    field: "clientRep.0.data.clientRepPhoneNo",
    validation: hasMinLength(8)
  },
  {
    field: "clientRep.0.data.clientRepPhoneNo",
    validation: maxLengthNotExceeding(20)
  }
];

const clientRepDocs = [
  {
    field: "clientRep.0.data.clientRepIdDocType",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepDocCountry",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepDocIssueDate",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepDocNo",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepDocNo",
    validation: maxLengthNotExceeding(20)
  },
  {
    field: "clientRep.0.data.clientRepDocValidDate",
    validation: hasStringValue
  },
  {
    field: "clientRep.0.data.clientRepMandatValidDate",
    validation: hasStringValue
  }
];

export const getStep3Validations = ({ otherCeoCitizen = 0, showRepFields = false }) => {
  const CEO_VALIDATIONS = [
    ...!showRepFields ? WhoOpenAccount : [],
    ...clientCeo,
    ...clientCeoAddress,
    ...clientCeoDocs
  ];
  const REP_VALIDATIONS = [...clientRep, ...clientRepAddress, ...clientRepDocs];
  if ((otherCeoCitizen === 1 || otherCeoCitizen === "1") && showRepFields) {
    return [...CEO_VALIDATIONS, ...REP_VALIDATIONS, ...otherCeoCitizien];
  }

  if ((otherCeoCitizen === 1 || otherCeoCitizen === "1") && !showRepFields) {
    return [...CEO_VALIDATIONS, ...otherCeoCitizien];
  }

  if ((otherCeoCitizen === 0 || otherCeoCitizen === "0") && showRepFields) {
    return [...CEO_VALIDATIONS, ...REP_VALIDATIONS];
  }

  return CEO_VALIDATIONS;
};
